<template>
  <div id="login-wrapper">
    <div id="login-box">
      <el-tabs v-model="active_tab">
        <el-tab-pane label="登陆" name="login">
          <div class="tab-content-box">
            <el-form :model="form_login" :rules="rules_login">
              <el-form-item>
                <h2>{{ system_name }}</h2>
              </el-form-item>
              <el-form-item prop="account" v-show="is_auto">
                <el-autocomplete placeholder="请输入内容" clearable class="input mb20" v-model="form_login.account"
                  :fetch-suggestions="querySearch" :trigger-on-focus="false">
                  <template #default="{ item }">
                    <div class="value" :title="item.value">
                      {{ item.value }}
                    </div>
                  </template></el-autocomplete>
              </el-form-item>
              <el-form-item prop="account" v-show="!is_auto">
                <el-input class="input mb20" type="text" placeholder="请输入账号" v-model="form_login.account" />
              </el-form-item>
              <el-form-item prop="password">
                <el-input class="input mb20" type="password" placeholder="请输入密码" v-model="form_login.password" />
              </el-form-item>
              <el-form-item>
                <el-button class="btn" type="primary" @click="onLogin()" style="width: 100%">登录</el-button>
              </el-form-item>
              <el-form-item>
                <el-link @click="showForget()">忘记密码</el-link>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="注册" name="register">
          <div class="tab-content-box">
            <el-form :model="form_register" :rules="rules_register">
              <el-form-item>
                <h2>{{ system_name }}</h2>
              </el-form-item>
              <el-form-item prop="name">
                <el-input class="input mb20" type="text" placeholder="请输入公司名称" v-model="form_register.name" />
              </el-form-item>
              <el-form-item prop="real_name">
                <el-input class="input mb20" type="text" placeholder="请输入联系人" v-model="form_register.real_name" />
              </el-form-item>
              <el-form-item prop="account">
                <el-input class="input mb20" type="text" placeholder="请输入用户名" v-model="form_register.account" />
              </el-form-item>
              <el-form-item prop="mobile">
                <el-input class="input mb20" type="text" placeholder="请输入手机号" v-model="form_register.mobile" />
              </el-form-item>
              <el-form-item prop="password">
                <el-input class="input mb20" type="password" placeholder="请输入密码" v-model="form_register.password">
                </el-input>
              </el-form-item>
              <el-form-item prop="verification_code">
                <el-input class="input mb20" type="text" placeholder="请输入验证码" v-model="form_register.verification_code">
                  <template #append>
                    <el-button type="primary" @click="onSendVerificationCode(form_register.mobile)">获取验证码</el-button>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button class="btn" type="primary" @click="onRegister()" style="width: 100%">注册</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog v-model="is_show_forget" title="忘记密码" width="400px">
      <el-form :model="form_forget" :rules="rules_register">
        <el-form-item prop="mobile">
          <el-input class="input mb20" type="text" placeholder="请输入手机号" v-model="form_forget.mobile" />
        </el-form-item>
        <el-form-item prop="verification_code">
          <el-input class="input mb20" type="text" placeholder="请输入验证码" v-model="form_forget.verification_code">
            <template #append>
              <el-button type="primary" @click="onSendVerificationCode(form_forget.mobile)">获取验证码</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input class="input mb20" type="password" placeholder="请输入密码" v-model="form_forget.password">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn" type="primary" @click="onForget()" style="width: 100%">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { api, session, config } from "@/assets/js/util.js";

export default {
  name: "Login",
  data() {
    return {
      is_show_forget: false,
      active_tab: "login",
      system_name: "青岛精科商城",
      form_login: {
        password: 666666,
      },
      form_register: {},
      form_forget: {},
      sms_ok: false,
      return_url: "",
      is_auto: true,
      is_sso: false,
      rules_login: {
        account: [
          {
            required: true,
            message: "账号不可为空",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "密码不可为空",
            trigger: "blur",
          },
        ],
      },
      rules_register: {
        name: [
          {
            required: true,
            message: "公司名称不能为空",
            trigger: "blur",
          },
        ],
        real_name: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur",
          },
        ],
        account: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        verification: [
          {
            required: true,
            message: "请输入短信验码",
            trigger: "blur",
          },
        ],
      },
      rules_forget: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        verification: [
          {
            required: true,
            message: "请输入短信验码",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    if (this.$route.path.indexOf("login") !== -1) {
      this.active_tab = "login";
    }
    if (this.$route.path.indexOf("register") !== -1) {
      this.active_tab = "register";
    }
    if (this.$route.query["return_url"]) {
      this.return_url = this.$route.query["return_url"];
    } else {
      this.return_url = '';
    }
  },
  methods: {
    showForget() {
      this.is_show_forget = true;
    },
    querySearch(queryString, callback) {
      api.get("get_customer", { query: queryString }).then(function (res) {
        if (res.code) {
          callback(res.data.list);
        }
      });
    },
    uuid: function () {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid;
    },
    onLogin: function () {
      let that = this;
      this.form_login.uuid = this.uuid();
      api.post("login", this.form_login).then(function (res) {
        if (res.code) {
          config.set("token", res.data.token);
          config.set("nickname", res.data.name);
          config.set("avatar", res.data.avatar);
          config.set("is_login", true);
          config.set("pid", res.data.pid);
          config.set("uuid", that.form_login.uuid);

          that.$message({
            type: "success",
            message: res.msg,
            duration: 1200,
            onClose: function () {
              if (that.return_url.length > 0) {
                that.$router.push(that.return_url);
              } else {
                that.$router.push("/");
              }
            },
          });
        } else {
          that.$message(res.msg);
          return false;
        }
      });
    },
    onRegister: function () {
      let that = this;
      if (!that.sms_ok) {
        that.$message({
          type: "error",
          message: "验证码错误",
          duration: 1200,
        });
        return false;
      }
      api.post("register", this.form_register).then(function (res) {
        if (res.code) {
          session.set("token", res.data.token);
          session.set("nickname", res.data.name);
          session.set("avatar", res.data.avatar);
          session.set("is_login", true);
          session.set("pid", res.data.pid);

          that.$message({
            type: "success",
            message: res.msg,
            duration: 1200,
            onClose: function () {
              if (that.return_url.length > 0) {
                that.$router.push(that.return_url);
              } else {
                that.$router.push("/");
              }
            },
          });
        } else {
          that.$message(res.msg);
          return false;
        }
      });
    },
    onForget() {
      let that = this;
      if (!that.sms_ok) {
        that.$message({
          type: "error",
          message: "验证码错误",
          duration: 1200,
        });
        return false;
      }
      api.post("forget", this.form_forget).then(function (res) {
        if (res.code) {
          that.$message({
            type: "success",
            message: res.msg,
            duration: 1200,
            onClose: function () {
              that.is_show_forget = false;
            },
          });
        } else {
          that.$message(res.msg);
          return false;
        }
      });
    },
    onSendVerificationCode(phone) {
      alert(phone);
      let that = this;
      if (!/^1(3|4|5|7|8)\d{9}$/.test(phone)) {
        that.$message({
          type: "error",
          message: "手机号码错误",
          duration: 1200,
        });
        return false;
      }
      api.post("send_sms", { mobile: phone }).then(function (res) {
        if (res.code) {
          that.sms_ok = true;
          that.$message({
            type: "success",
            message: "发送成功",
            duration: 1200,
          });
        } else {
          that.$message({
            type: "error",
            message: res.msg,
            duration: 1200,
          });
        }
      });
    },
  },
};
</script>

<style>
#login-wrapper {
  width: 100%;
  height: 100%;
  background-color: #2794eb;
}

#login-box {
  position: absolute;
  right: 250px;
  top: 160px;
  background: #fff;
  width: 450px;
  padding: 20px;
  padding-bottom: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 7px 0 rgba(5, 34, 97, 0.1);
}

#login-box .el-tabs__nav {
  width: 100%;
}

#login-box .el-tabs__item {
  text-align: center;
  width: 50% !important;
  font-size: 16px;
  height: 60px;
  line-height: 60px;
}

#login-box .tab-content-box {
  padding-left: 50px;
  padding-right: 50px;
}

#login-box .tab-content-box h2 {
  text-align: center;
  font-size: 32px;
  height: 100px;
  line-height: 100px;
  margin: 0px;
  color: #555;
  font-weight: normal;
}

#login-box .tab-content-box h4 {
  text-align: center;
  height: 50px;
  line-height: 50px;
  margin: 0px;
  color: #555;
}

#login-box .input {
  width: 100% !important;
}

#login-box .input .el-input__inner {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
}

#login-box .btn {
  padding: 0px;
  height: 50px;
  line-height: 50px;
}

#login-box .btn span {
  display: inline-block;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
}

@media screen and (max-width: 768px) {
  #login-box {
    width: 100% !important;
    right: 0px;
    top: 0px;
    border-radius: 0px;
    box-shadow: none;
    left: 0px;
  }

  h2 {
    width: 100% !important;
    text-align: center !important;
  }
}
</style>
